import { string } from 'yup';

const kvkNumber = () =>
  string().matches(/^[0-9]{8}$/, {
    excludeEmptyString: true,
    message: 'INVALID',
  });

export default kvkNumber;
